import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { useState } from 'react'

interface Props {
  open: boolean
  onClose: () => void
}

export default function FuturesLocalPriceDialog({ open, onClose }: Props) {
  const [asOfDate, setAsOfDate] = useState(() => new Date().toISOString().slice(0, 10))

  const handleRefresh = () => {
    // Placeholder for local price refresh/load behavior from the Access local price forms.
    void asOfDate
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" fontWeight={700}>
          Input Local Price
        </Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ pt: 1.5 }}>
        <Stack spacing={2}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
            <Typography variant="body2" fontWeight={700}>
              Date:
            </Typography>
            <TextField
              size="small"
              type="date"
              value={asOfDate}
              onChange={(event) => setAsOfDate(event.target.value)}
              sx={{ width: 180 }}
              inputProps={{ 'aria-label': 'Local Price date' }}
            />
            <Button variant="outlined" size="small" onClick={handleRefresh}>
              Refresh Data
            </Button>
          </Box>

          <Typography variant="body2" color="text.secondary">
            This dialog is wired from the Access header action <strong>btnLocalPrice</strong>. The final grid and save
            behavior must follow <strong>form_frmFuturesQryLocalPriceAdd.txt</strong>,{' '}
            <strong>form_frmFuturesQryLocalPriceAdd_subForm.txt</strong>, and the physical price queries.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 2, py: 1.25 }}>
        <Button variant="outlined" size="small" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
